import { postShoppingCart } from 'services/apis/submit-shopping';
import { SUBMIT_ITEM_TO_SHOPPING_CART } from 'constants/shopping-cart';

export const postShoppingCartAction = (data) => ({
  type: SUBMIT_ITEM_TO_SHOPPING_CART,
  payload: postShoppingCart(data),
});
